import $ from 'jquery';

export class SearchPulldown {
  constructor($trigger) {
    this.$trigger = $trigger;
    this.$search = $('.js-search-pulldown');
    this.bindEvents();
  }
  
  bindEvents() {
    this.$trigger.on('click', event => this.onTriggerClick(event));
  }
  
  onTriggerClick() {
    $('body').toggleClass('is-pulldown');
    if ($('body').hasClass('is-pulldown')) {
      this.$search.find('input').trigger('focus');
    }
  }
}